import {ToolBarContainer,} from "./styled";
import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/store";
import {changeFilter, getOrders} from "../../../../redux/slices/orders-slice";
import {OrderFilterModel} from "../../../shared/models/order/order-filter.model";
import {Divider} from "@mui/material";
import ToolPanelButtons from "./tool-panel-buttons/tool-panel-buttons";
import {OrderFilter} from "./filter/order-filter";
import {
    GenericActionTypes,
    InWarehouseActionTypes,
    OrderPopupActionTypes,
    ReadyForShipmentActionTypes
} from "../../../../management-pages/actions/action-types.enum";
import {ActionDialog} from "../../../../management-pages/actions/dialogs/action-dialog";
import {ToolPanelProps} from "./tool-panel";
import {SearchInput} from "./filter/search-input";

export const BarekamToolPanel = ({selectedOrders}: ToolPanelProps) => {
    const {filter, orderStateId} = useAppSelector(state => state.ordersReducer);

    const {matchesPhone} = useAppSelector(state => state.deviceReducer);

    const [mobileFilterOpened, setMobileFilterOpened] = useState(false);
    const [activeAction, setActiveAction] = useState<GenericActionTypes | InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes>();

    const dispatch = useAppDispatch();

    function handleFilterChange(modifiedFilter: OrderFilterModel) {
        dispatch(changeFilter(modifiedFilter));
        dispatch(getOrders({page: 0}));
    }

    return (
        <ToolBarContainer style={{paddingTop: '1rem'}}>
            <OrderFilter onFilterChange={handleFilterChange}
                         mobileFilterOpened={mobileFilterOpened}
                         setMobileFilterOpened={setMobileFilterOpened}/>

            {matchesPhone ? '' : <Divider style={{width: '100%'}}/>}

            <div style={{display: 'flex', justifyContent: 'space-between', gap: '0.5rem', overflowX: 'auto', flexDirection: matchesPhone ? 'column' : 'row'}}>
                <SearchInput filter={filter} filterChanged={handleFilterChange}/>

                <div style={{display: 'flex', minHeight: '1.75rem'}}>
                    <ToolPanelButtons isWarehouseWorker={false} onFilterClicked={() => setMobileFilterOpened(true)}/>
                </div>
            </div>

            <ActionDialog open={!!activeAction}
                          closePopup={() => setActiveAction(undefined)}
                          action={activeAction}
                          orderStateId={orderStateId}
                          predefinedOrders={Array.from(selectedOrders ? selectedOrders.values() : [])}/>
        </ToolBarContainer>
    )
}
